<template>
	<div class="detail-info">
		<el-form ref="detailInfoRef" :model="formData" :rules="formRules" label-width="100px" label-position="top">
			<!-- 附件上传 -->
			<div class="section">
				<div class="section-title">
					附件资料
					<span class="section-sub">（支持 Word、PDF 格式）</span>
				</div>

				<el-row :gutter="40">
					<el-col :span="24">
						<el-form-item label="" prop="attachments">
							<UploadDragFiles
								ref="uploadFilesRef"
								v-model="formData.attachments"
								:action="uploadAction"
								:preview-url="previewUrl"
								:delete-api="deleteApi"
								:delete-params="deleteParams"
								:data="uploadData"
								accept=".doc,.docx,.pdf"
								:limit="5"
								:size="20"
								upload-button-text="上传附件"
							/>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
		</el-form>
	</div>
</template>

<script>
	/**
	 * @description 购买流程-详情页信息组件
	 */

	import UploadDragFiles from '@/components/UploadDragFiles/index.vue'
	import { uploadMerchantFile, previewMerchantFile, deleteMerchantFile, queryMerchantFileList } from '@/api/mall'
	import { FILE_BUSINESS_TYPE } from '@/enum'

	export default {
		name: 'DetailInfo',
		components: {
			UploadDragFiles
		},
		props: {
			// 页面级业务ID
			businessId: {
				type: String,
				default: ''
			},
			// 是否重新提交
			resubmit: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				disabled: false,

				formData: {
					// detailsPage: '',
					attachments: []
				},
				formRules: {
					attachments: [
						{
							required: true,
							message: '请上传附件资料',
							trigger: 'change',
							validator: (rule, value, callback) => {
								if (!value || value.length === 0) {
									callback(new Error('请上传附件资料'))
								} else {
									callback()
								}
							}
						}
					]
				},
				// 上传配置
				uploadAction: uploadMerchantFile(),
				previewUrl: previewMerchantFile(),
				deleteApi: deleteMerchantFile,
				deleteParams: {}
			}
		},
		computed: {
			// 上传额外参数
			uploadData() {
				return {
					businessId: this.businessId,
					fileBusinessType: FILE_BUSINESS_TYPE.ATTACHMENT
				}
			}
		},
		created() {
			if (this.resubmit) {
				this.getAttachments()
			}
		},
		methods: {
			// 获取附件资料
			getAttachments() {
				queryMerchantFileList({
					businessId: this.businessId,
					fileBusinessType: FILE_BUSINESS_TYPE.ATTACHMENT
				}).then(response => {
					const { data } = response || {}
					const list = Array.isArray(data) ? data : []
					this.formData.attachments = list.map(item => ({
						name: item.fileName || item.name,
						fileSize: item.fileSize || item.size,
						fileId: item.id,
						url: previewMerchantFile() + item.id,
						uid: item.id
					}))
				})
			},

			getFormData() {
				return { ...this.formData }
			},
			validate() {
				return new Promise((resolve, reject) => {
					this.$refs.detailInfoRef.validate(valid => {
						if (valid) {
							resolve(this.getFormData())
						} else {
							reject(new Error('详情页信息表单校验失败'))
						}
					})
				})
			},
			resetForm() {
				this.formData.attachments = []
				this.$refs.uploadFilesRef && this.$refs.uploadFilesRef.clearFiles()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.detail-info {
		padding: 20px;
	}

	.section {
		margin-bottom: 24px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.section-title {
		font-size: 14px;
		font-weight: bold;
		color: #303133;
		margin-bottom: 12px;
		padding-left: 10px;
		position: relative;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 3px;
			height: 14px;
			background-color: #2671cb;
			border-radius: 2px;
		}
	}

	.section-sub {
		font-size: 12px;
		color: #909399;
		font-weight: normal;
		margin-left: 4px;
	}
</style>
